import { t } from "i18next";
import React from "react";

const RegistrationTotal = (props) => {
  const { totalAED, totalUSD, conferenceDetails } = props;
  const isAED = conferenceDetails?.currencyType === "aed";
  const isUSD = conferenceDetails?.currencyType === "usd";
  const isBOTH = conferenceDetails?.currencyType === "both";
  return (
    <div className="d-flex justify-content-between">
      <h5>{t("total")}</h5>
      {isAED && <h5>{`AED ${totalAED.toFixed(2)}`}</h5>}
      {isUSD && <h5>{`USD ${totalUSD}`}</h5>}
      {isBOTH && (
        <h5>
          {`AED ${totalAED.toFixed(2)}`}
          <span className="fs-6">{` (USD ${totalUSD})`}</span>
        </h5>
      )}
    </div>
  );
};

export default RegistrationTotal;
